import { GridColumnProps } from '@progress/kendo-react-grid'
import { DepartmentType } from 'api/Identity/Types/DepartmentType'
import { UserFilterKey } from 'api/Identity/Types/UserResponse'
import {
  SelectAssignTableProps,
  SelectItemEvent,
  SelectItemsEvent,
  SelectUsersAssignTable,
} from 'components/SelectOverviewTable/SelectUsersAssignTable'
import { initialState } from 'store/grid'
import { BuildQueryProps, FilterLogic } from 'utils/QueryHelpers'

export interface GridColumn extends GridColumnProps {
  width?: number
}

export type SelectIBSEvent = SelectItemsEvent
export type SelectIBEvent = SelectItemEvent

export type SelectTicketsAssignTableProps = Omit<SelectAssignTableProps, 'query'>

export const SelectIBSAssignTable = (props: SelectTicketsAssignTableProps): JSX.Element => {
  return <SelectUsersAssignTable {...props} query={createUsersAssignQuery()} />
}

const createUsersAssignQuery = (): BuildQueryProps => {
  const initialGridState = initialState()

  return {
    ...initialGridState.filter,
    logic: FilterLogic.AND,
    defaultFilters: {
      logic: FilterLogic.AND,
      filters: [
        {
          field: UserFilterKey.departments,
          operator: '==',
          value: DepartmentType.Partnership,
        },
      ],
    },
  }
}
